import ManualWithdrawProfitFromChallengeForm from './ManualWithdrawProfitFromChallengeForm';

export default ManualWithdrawProfitFromChallengeForm;
